<template>
    <span>
        <div class="vx-row ml-3 mt-8 mb-4">
            <div class="vx-col-w-full flex">
                <vs-checkbox color="primary" v-model="is_tab_expand" icon-pack="feather" icon="icon-check"
                    class="font-bold">Show tab titles</vs-checkbox>
            </div>
        </div>
        <div class="vx-row">
            <div class="w-full vx-col">
                <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs"
                    :key="isSmallerScreen" :value="active_step">
                    <vs-tab icon-pack="feather" icon="icon-file" :label="is_expand ? 'Manage Sage Account' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <ManageSage />
                        </div>
                    </vs-tab>
                    <vs-tab v-if="$canAny(['view-sage-nominal-code'])" icon-pack="feather" icon="icon-briefcase"
                        :label="is_expand ? 'Sage Departments' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <sage-departments-settings />
                        </div>
                    </vs-tab>
                    <vs-tab v-if="$canAny(['view-sage-nominal-code'])" icon-pack="feather" icon="icon-briefcase"
                        :label="is_expand ? 'Sage Nominal Codes' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <sage-nominal-code-settings />
                        </div>
                    </vs-tab>
                    <vs-tab v-if="$canAny(['create-edit-sage-supplier'])" icon-pack="feather" icon="icon-briefcase"
                        :label="is_expand ? 'Sage Supplier Types' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <sage-supplier-types-settings />
                        </div>
                    </vs-tab>
                </vs-tabs>
            </div>
        </div>
    </span>
</template>

<script>
import ManageSage from '@/views/pages/settings/General/manage-sage/ManageSage.vue'
import SageDepartmentsSettings from "@/views/pages/settings/General/SageDepartmentsSettings";
import SageNominalCodeSettings from "@/views/pages/settings/General/SageNominalCodeSettings";
import SageSupplierTypesSettings from "@/views/pages/settings/General/SageSupplierTypesSettings";

export default {
    name: 'FinancialSettings',
    data() {
        return {
            is_expand: true,
            tab_mapping: {
                'manage_sage': 0,
                'sage_nominal_code': 1,
                'sage_departments': 2,
            }
        }
    },
    components: {
        ManageSage,
        SageDepartmentsSettings,
        SageNominalCodeSettings,
        SageSupplierTypesSettings
    },
    computed: {
        isSmallerScreen() {
            return this.$store.state.windowWidth < 768
        },
        is_tab_expand: {
            get() { return this.is_expand },
            set(val) { this.is_expand = val }
        },
        active_step() {
            let tabParam = this.$route.query.tab;
            if (tabParam) {
                tabParam = tabParam.split('?')[0];
            }
            if (!tabParam) return 0;
            const tabValues = tabParam.split(' ');
            for (const tab of tabValues) {
                if (this.tab_mapping[tab]) {
                    return this.tab_mapping[tab];
                }
            }

            return 0;
        }
    },
}
</script>
<style lang="">

</style>